import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import axios from 'axios'
import i18n from './i18n/config'
import 'bootstrap/dist/css/bootstrap.css'
import { HB_APP, Honeybadger, installHoneybadger } from './plugins/honeybadger'

Vue.config.productionTip = false
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

installHoneybadger(Vue, process.env)

// Which screen the player was on. Set on every navigation rather than once,
// since an SPA otherwise reports every error under the route it booted at.
// Gated on the same key check buildHoneybadgerConfig uses, so without a key
// the client is configured but reports nothing, since reportData is false.
if (process.env.VUE_APP_HONEYBADGER_API_KEY) {
    router.afterEach((to) => {
        // Unnamed parameterised routes would otherwise mint one Honeybadger
        // component per record id; the URL is already on the fault, so a coarse
        // bucket loses nothing.
        const screen = to.name ? String(to.name) : 'unnamed'
        Honeybadger.configure({ component: `${HB_APP}:${screen}` })
        Honeybadger.setContext({ route: screen })
    })
}

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app')
